// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as URLUtils$Showside from "./URLUtils.bs.js";
function fromMeta(meta) {
  var page = meta.page;
  var page$1 = page == null ? undefined : Caml_option.some(page);
  var product = meta.product;
  var resourceId = Belt_Option.flatMap(Belt_Option.map(page$1, function (prim) {
    return prim.resourceId;
  }), function (prim) {
    if (prim == null) {
      return;
    } else {
      return Caml_option.some(prim);
    }
  });
  var resourceType = Belt_Option.flatMap(Belt_Option.map(page$1, function (prim) {
    return prim.resourceType;
  }), function (prim) {
    if (prim == null) {
      return;
    } else {
      return Caml_option.some(prim);
    }
  });
  if (resourceType === undefined) {
    return;
  }
  switch (resourceType) {
    case "collection":
      if (resourceId !== undefined) {
        return {
          TAG: /* CollectionPage */0,
          collectionId: resourceId.toString()
        };
      } else {
        return;
      }
    case "product":
      if (resourceId !== undefined) {
        return {
          TAG: /* ProductPage */1,
          productId: resourceId.toString(),
          variants: Belt_Option.getWithDefault(Belt_Option.flatMap(Belt_Option.map(product == null ? undefined : Caml_option.some(product), function (prim) {
            return prim.variants;
          }), function (prim) {
            if (prim == null) {
              return;
            } else {
              return Caml_option.some(prim);
            }
          }), [])
        };
      } else {
        return;
      }
    default:
      return;
  }
}
var Page = {
  fromMeta: fromMeta
};
function initialDocumentCookie(param) {
  return Belt_Option.flatMap(Belt_Option.map(Belt_Option.flatMap(Belt_Option.map(Belt_Option.flatMap(Belt_Option.map(window.ShopifyAnalytics == null ? undefined : Caml_option.some(window.ShopifyAnalytics), function (prim) {
    return prim.lib;
  }), function (prim) {
    if (prim == null) {
      return;
    } else {
      return Caml_option.some(prim);
    }
  }), function (prim) {
    return prim.config;
  }), function (prim) {
    if (prim == null) {
      return;
    } else {
      return Caml_option.some(prim);
    }
  }), function (prim) {
    return prim.initialDocumentCookie;
  }), function (prim) {
    if (prim == null) {
      return;
    } else {
      return Caml_option.some(prim);
    }
  });
}
function waitForShopifyAnalytics(retryCountOpt, param) {
  var retryCount = retryCountOpt !== undefined ? retryCountOpt : 0;
  var match = window.ShopifyAnalytics;
  var match$1 = retryCount > 25;
  if (!(match == null) || match$1) {
    return Promise.resolve(undefined);
  } else {
    return new Promise(function (resolve, reject) {
      setTimeout(function (param) {
        waitForShopifyAnalytics(retryCount + 1 | 0, undefined).then(function (result) {
          resolve(result);
        });
      }, 42);
    });
  }
}
function getPage(param) {
  return Belt_Option.flatMap(Belt_Option.flatMap(Belt_Option.map(window.ShopifyAnalytics == null ? undefined : Caml_option.some(window.ShopifyAnalytics), function (prim) {
    return prim.meta;
  }), function (prim) {
    if (prim == null) {
      return;
    } else {
      return Caml_option.some(prim);
    }
  }), fromMeta);
}
function getProductPageProductId(param) {
  return Belt_Option.flatMap(getPage(undefined), function (page) {
    if (page.TAG === /* CollectionPage */0) {
      return;
    } else {
      return page.productId;
    }
  });
}
function getCollectionPageCollectionId(param) {
  return Belt_Option.flatMap(getPage(undefined), function (page) {
    if (page.TAG === /* CollectionPage */0) {
      return page.collectionId;
    }
  });
}
function getProductPageVariantId(param) {
  var variants = Belt_Option.mapWithDefault(getPage(undefined), [], function (page) {
    if (page.TAG === /* CollectionPage */0) {
      return [];
    } else {
      return page.variants;
    }
  });
  var idToFind = URLUtils$Showside.getParam(window.location.href, "variant");
  var foundVariant = idToFind !== undefined ? Belt_Array.getBy(variants, function (v) {
    var currentId = Belt_Option.map(Caml_option.nullable_to_opt(v.id), function (prim) {
      return prim.toString();
    });
    return Caml_obj.equal(currentId, idToFind);
  }) : undefined;
  var firstVariant = Belt_Array.get(variants, 0);
  return Belt_Option.map(Belt_Option.flatMap(Belt_Option.map(Belt_Option.orElse(foundVariant, firstVariant), function (prim) {
    return prim.id;
  }), function (prim) {
    if (prim == null) {
      return;
    } else {
      return Caml_option.some(prim);
    }
  }), function (prim) {
    return prim.toString();
  });
}
function isProductPage(param) {
  if (Belt_Option.isSome(getProductPageProductId(undefined))) {
    return true;
  } else {
    return window.location.pathname.includes("/products/");
  }
}
export { Page, initialDocumentCookie, waitForShopifyAnalytics, getPage, getProductPageProductId, getCollectionPageCollectionId, getProductPageVariantId, isProductPage };
/* No side effect */